var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ErrorHistory"},[(_vm.nowPage == '即時維修狀態')?[_c('maintainStatus')]:(_vm.nowPage == '維修履歷')?[_c('maintainLog')]:(_vm.nowPage == '警報履歷')?[_c('alarmHistory')]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1479f05f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ErrorHistory.vue
// module id = null
// module chunks = 